import React, { useEffect, useState } from 'react';
import { SolicitationView } from '../../../../models/SolicitationView';
import { WorkView } from '../../../../models/WorkView';
import Modal from '../../../../components/Dialog/Modal';
import LcLoading from '../../../../components/Generic/LcLoading';
import LCFlexContainer from '../../../../components/Layout/LCFlexContainer';
import LCFlexItem from '../../../../components/Layout/LCFlexItem';
import { PPTextField } from 'processor-plataform-ui';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { UserState } from '../../../../store/reducers/userReducer';
import { Validate } from '../PauseWork';
import WorkService from '../../../../services/WorkService/WorkService';
import LcCheckBox from '../../../../components/Form/LcCheckBox';

interface PropsWorkList {
    work: WorkView;
    solicitation: SolicitationView;
    onCloseEvent: Function;
    open: boolean;
    content: string;
    confirmMessage: string;
    idConfirm?: string;
    abortMessage: string;
    type: number;
    idAbort?: string;
}

const AproveWork: React.FC<PropsWorkList> = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const [loading, setLoading] = useState<boolean>(false)
    const [comment, setComment] = useState<string>('');
    const [validations, setValidations] = useState<Validate[]>([]);
    const [workService, setWorkService] = useState<WorkService>(new WorkService(props));
    const [visibleRequester, setVisibleRequester] = useState<boolean>(true);

    const approveReproveWork = async () => {
        setLoading(true);

        if (validateRules() === false) {
            setLoading(false);
            return true;
        }

        try {
            const approvedWorks = {
                works: {
                    NewWork: {
                        ...props.work,
                        idSolicitation: props.solicitation.id,
                        idUserRegistration: user.id as number,
                        idUser: (props.work.idUser != 0) ? props.work.idUser as number : null,
                        nameUser: (props.work.idUser != 0) ? props.work.nameUser : null,
                        nameUserRegistration: user.name,
                        description: comment,
                        idStatus: 1
                    },
                    UpdateWork: {
                        ...props.work,
                        idSolicitation: props.solicitation.id,
                        idUserRegistration: user.id as number,
                        nameUserRegistration: user.name,
                        idUser: (props.work.idUser) ? props.work.idUser as number : user.id as number,
                        nameUser: props.work.nameUser,
                        workRealized: comment,
                        externalComment: visibleRequester,
                        idStatus: 7
                    }
                },
                approved: props.type === 7
            }

            await workService.approvalFlow(approvedWorks);

            if (props.onCloseEvent !== null) {
                props.onCloseEvent(true);
            }
        }
        catch (error) {
            console.debug(error);

            try {
                const response = await workService.GetById(props.work.id);

                if (response.data.idStatus === 7) {
                    props.onCloseEvent(true);
                }
            }
            catch (error) {
                debugger;
            }
        }

        setLoading(false)
    }

    const validateRules = () => {
        var validationsChecks: Validate[] = [];

        if ((comment.length === 0)) {
            validationsChecks.push({
                name: 'comment',
                validateMessage: 'Deve possuir comentário preenchido',
                valid: false
            });
        }

        if (validationsChecks.length !== 0) {
            setValidations(validationsChecks);
        }

        return validationsChecks.length === 0;
    }

    return (
        <Modal
            title={(props.type === 7) ? 'Aprovar trabalho' : "Reprovar trabalho"}
            close={() => { if (props.onCloseEvent !== null) props.onCloseEvent(false); }}
            visible={props.open}>
            <LcLoading loading={loading} label={"Carregando..."}>
                <LCFlexContainer spacing={2}>
                    <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                        <LcCheckBox
                            name={'show'}
                            title={'Visivel para o solicitante'}
                            checked={visibleRequester}
                            onChange={() => setVisibleRequester(!visibleRequester)} />
                    </LCFlexItem>
                    <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                        <PPTextField
                            required
                            multiline
                            onChange={(e) => setComment(e.target.value)}
                            label={'Comentário'}
                            name={'comment'}
                            minRows={4}
                            maxRows={4}
                            value={comment}
                            help={validations.find(x => 'comment' === x.name)?.validateMessage}
                            error={validations.find(x => 'comment' === x.name) !== undefined}
                        // help={comment.length >= 5 ? '' : 'É precisa digitar um comentário' }
                        // error={comment.length <= 5 && comment.length !== 0 }
                        />
                    </LCFlexItem>
                    <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                        <div className={"row end"}>
                            <button
                                style={{ margin: '10px' }}
                                className={'lc-button bg-info'}
                                id={'Ok'}
                                onClick={() => approveReproveWork()}
                                color={"primary"}>
                                Salvar
                            </button>
                            <button
                                style={{ margin: '10px' }}
                                className={'lc-button bg-info-alt'}
                                id={'Cancelar'}
                                onClick={() => {
                                    if (props.onCloseEvent !== null) props.onCloseEvent(false);
                                }}
                                color={"primary"}
                            >
                                Cancelar
                            </button>
                        </div>
                    </LCFlexItem>
                </LCFlexContainer>
            </LcLoading>
        </Modal>
    )
}

export default AproveWork;